import { apartmentsComApi } from "api/apartmentsCom";
import { useMutation } from "@tanstack/react-query";
import { useNavigate } from "react-router-dom";
import { Layout } from "providers/Layout";
import { useAuthContext } from "providers/Auth";
import { IntegrationId } from "views/settings-integration/components/AddIntegrationModal/types";
import { FeedListingsCard } from "views/settings-integration/integrations/shared/FeedListingsCard";
import { IntegrationDetailHeader } from "views/settings-integration/integrations/shared/IntegrationDetailHeader";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";

export const ApartmentsComView = () => {
  const navigate = useNavigate();
  const { refreshPartnerData } = useAuthContext();

  const { mutate: disconnect, isPending: isDisconnecting } = useMutation({
    mutationKey: ["APARTMENTS_COM", "DELETE"],
    mutationFn: () => apartmentsComApi.disconnect(),
    onSuccess: () => {
      toast.success("Apartments.com integration disconnected successfully");
      refreshPartnerData();
      navigate("/settings/integration");
    },
    onError: (err) => {
      toast.error(getErrorMessage(err));
    }
  });

  return (
    <Layout
      header={
        <IntegrationDetailHeader
          id={IntegrationId.APARTMENTS_COM}
          name="Apartments.com"
          path="/settings/integration/apartments-com"
          onDisconnect={() => disconnect()}
          isDisconnecting={isDisconnecting}
        />
      }
    >
      <FeedListingsCard feed="apartments_com" feedLabel="Apartments.com" />
    </Layout>
  );
};
